import * as d3Scale from 'd3-scale';
import { Scale, ScaleString } from '../Types';

export const getScaleBandWidth = (scale: Scale) => {
  if ('bandwidth' in scale) {
    return scale.bandwidth();
  }

  return 0;
};


export const getScaleInvert = (scale: Scale) => {
  if ('invert' in scale) {
    return scale.invert;
  }

  const domain = scale.domain();
  const range = scale.range();
  const reverse = range[0] > range[1];

  if (!domain.length) {
    return () => range[0];
  }

  return d3Scale
    .scaleQuantize()
    .domain(reverse ? [range[1], range[0]] : range)
    .range(reverse ? domain.reverse() : domain);
};


export const getScalePadding = (scale: Scale) => {
  if ('paddingOuter' in scale) {
    const [rangeStart] = scale.range();
    const [domainStart] = scale.domain();
    const padding = scale(domainStart);
    return padding === undefined ? 0 : padding - rangeStart;
  }

  return 0;
};

export const getScaleTicks = (scale: Scale, n?: number) => {
  if ('ticks' in scale) {
    return scale.ticks(n);
  }

  return scale.domain();
};

interface Props {
  domain?: number[];
  paddingInner?: number;
  paddingOuter?: number;
  range?: [number, number];
}

export default (scale: ScaleString, props: Props = {}) => {
  switch (scale) {
    case 'band':
      return d3Scale
        .scaleBand<number>()
        .domain(props.domain || [0, 1])
        .range(props.range || [0, 1])
        .paddingInner(props.paddingInner || 0)
        .paddingOuter(props.paddingOuter || 0);
    case 'linear':
      return d3Scale
        .scaleLinear<number, number>()
        .domain(props.domain || [0, 1])
        .range(props.range || [0, 1]);
  }
};
